'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnalyticsActionTypes = (0, _keyMirror2.default)({
  ANALYTICS_USER_NEW: null,
  ANALYTICS_USER_EXISTING: null,
  ANALYTICS_PORTAL_NEW: null,
  ANALYTICS_PORTAL_EXISTING: null
});

exports.default = AnalyticsActionTypes;
module.exports = exports['default'];